module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "BuyXGetYOff"
  }, [_c('b-modal', {
    attrs: {
      "hide-footer": "",
      "size": "lg",
      "visible": _vm.shown
    },
    on: {
      "hide": function($event) {
        _vm.$emit('hide')
      },
      "shown": _vm.reset
    }
  }, [_c('div', {
    staticClass: "w-100",
    slot: "modal-title"
  }, [_c('strong', [_vm._v(_vm._s(_vm.name))])]), _vm._v(" "), _c('div', {
    staticClass: "card"
  }, [_c('div', {
    staticClass: "card-header"
  }, [_c('ul', {
    staticClass: "nav nav-tabs card-header-tabs"
  }, [_c('li', {
    staticClass: "nav-item"
  }, [_c('a', {
    staticClass: "nav-link",
    class: {
      active: _vm.tab == 0
    },
    on: {
      "click": function($event) {
        _vm.tab = 0
      }
    }
  }, [_vm._v("Customer must buy")])]), _vm._v(" "), _c('li', {
    staticClass: "nav-item"
  }, [_c('a', {
    staticClass: "nav-link",
    class: {
      active: _vm.tab == 1
    },
    on: {
      "click": function($event) {
        _vm.tab = 1
      }
    }
  }, [_vm._v("Customer will get")])])])]), _vm._v(" "), (_vm.tab === 0) ? _c('div', {
    staticClass: "card-body"
  }, [_c('b-form-fieldset', {
    attrs: {
      "label": "at least"
    }
  }, [_c('b-input-group', {
    attrs: {
      "right": "items"
    }
  }, [_c('b-form-input', {
    attrs: {
      "type": "number",
      "min": "0",
      "step": "1",
      "rows": 1,
      "disabled": ""
    },
    model: {
      value: (_vm.promotion.requirements.purchasedAmount),
      callback: function($$v) {
        _vm.promotion.requirements.purchasedAmount = $$v
      },
      expression: "promotion.requirements.purchasedAmount"
    }
  })], 1)], 1), _vm._v(" "), _c('b-form-fieldset', {
    attrs: {
      "label": "up to"
    }
  }, [_c('b-input-group', {
    attrs: {
      "right": "items"
    }
  }, [_c('b-form-input', {
    attrs: {
      "type": "number",
      "min": "0",
      "step": "any",
      "rows": 1,
      "disabled": ""
    },
    model: {
      value: (_vm.promotion.rewards.redemptionLimit),
      callback: function($$v) {
        _vm.promotion.rewards.redemptionLimit = $$v
      },
      expression: "promotion.rewards.redemptionLimit"
    }
  })], 1)], 1), _vm._v(" "), _c('product-list', {
    attrs: {
      "value": _vm.promotion.requirements.purchasedProducts,
      "enableSubsidy": false
    }
  })], 1) : _vm._e(), _vm._v(" "), (_vm.tab === 1) ? _c('div', {
    staticClass: "card-body"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-5"
  }, [_c('b-form-fieldset', {
    attrs: {
      "label": "reward money"
    }
  }, [_c('b-input-group', {
    attrs: {
      "right": "CAD"
    }
  }, [_c('b-form-input', {
    attrs: {
      "type": "number",
      "min": "0",
      "step": "any",
      "rows": 1,
      "disabled": ""
    },
    model: {
      value: (_vm.promotion.rewards.rewardMoneyEarnedPerRedemption),
      callback: function($$v) {
        _vm.promotion.rewards.rewardMoneyEarnedPerRedemption = _vm._n($$v)
      },
      expression: "promotion.rewards.rewardMoneyEarnedPerRedemption"
    }
  })], 1)], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "col-2 text-center my-4 pt-3"
  }, [_vm._v("\n            and\n          ")]), _vm._v(" "), _c('div', {
    staticClass: "col-5"
  }, [_c('b-form-fieldset', {
    attrs: {
      "label": "rewards subsidy"
    }
  }, [_c('b-input-group', {
    attrs: {
      "right": "CAD"
    }
  }, [_c('b-form-input', {
    attrs: {
      "type": "number",
      "min": "0",
      "step": "any",
      "rows": 1,
      "disabled": ""
    },
    model: {
      value: (_vm.promotion.rewardsSubsidy),
      callback: function($$v) {
        _vm.promotion.rewardsSubsidy = _vm._n($$v)
      },
      expression: "promotion.rewardsSubsidy"
    }
  })], 1)], 1)], 1)]), _vm._v(" "), _c('b-form-fieldset', {
    attrs: {
      "label": "target margin"
    }
  }, [_c('b-input-group', {
    attrs: {
      "right": "%"
    }
  }, [_c('b-form-input', {
    attrs: {
      "type": "number",
      "min": "0",
      "step": "any",
      "rows": 1,
      "disabled": ""
    },
    model: {
      value: (_vm.promotion.targetMargin),
      callback: function($$v) {
        _vm.promotion.targetMargin = _vm._n($$v)
      },
      expression: "promotion.targetMargin"
    }
  })], 1)], 1), _vm._v(" "), _c('b-form-fieldset', {
    attrs: {
      "label": "for"
    }
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-5"
  }, [_c('b-input-group', {
    attrs: {
      "right": "CAD"
    }
  }, [_c('b-form-input', {
    attrs: {
      "type": "number",
      "min": "0",
      "step": "any",
      "rows": 1,
      "disabled": ""
    },
    model: {
      value: (_vm.promotion.rewards.sumOff),
      callback: function($$v) {
        _vm.promotion.rewards.sumOff = $$v
      },
      expression: "promotion.rewards.sumOff"
    }
  })], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "col-2 text-center"
  }, [_vm._v("or")]), _vm._v(" "), _c('div', {
    staticClass: "col-5"
  }, [_c('b-input-group', {
    attrs: {
      "right": "%"
    }
  }, [_c('b-form-input', {
    attrs: {
      "type": "number",
      "min": "0",
      "step": "any",
      "rows": 1,
      "disabled": ""
    },
    model: {
      value: (_vm.promotion.rewards.percentageOff),
      callback: function($$v) {
        _vm.promotion.rewards.percentageOff = $$v
      },
      expression: "promotion.rewards.percentageOff"
    }
  })], 1)], 1)])]), _vm._v(" "), _c('b-form-fieldset', {
    attrs: {
      "label": "from"
    }
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-5"
  }, [_c('b-input-group', {
    attrs: {
      "right": "times"
    }
  }, [_c('b-form-input', {
    staticClass: "sumOff",
    attrs: {
      "type": "number",
      "min": "0",
      "step": "any",
      "rows": 1
    },
    model: {
      value: (_vm.promotion.rewards.salesRedemptionLimit),
      callback: function($$v) {
        _vm.promotion.rewards.salesRedemptionLimit = _vm._n($$v)
      },
      expression: "promotion.rewards.salesRedemptionLimit"
    }
  })], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "col-2 text-center"
  }), _vm._v(" "), _c('div', {
    staticClass: "col-5"
  }, [_vm._v("\n              once per day:\n              "), _c('b-form-checkbox', {
    staticClass: "oncePerDay",
    attrs: {
      "size": "lg",
      "value": "1",
      "unchecked-value": "0",
      "switch": ""
    },
    on: {
      "input": function($event) {
        _vm.$v.promotion.oncePerDay.$touch()
      }
    },
    model: {
      value: (_vm.promotion.oncePerDay),
      callback: function($$v) {
        _vm.promotion.oncePerDay = $$v
      },
      expression: "promotion.oncePerDay"
    }
  })], 1)])])], 1) : _vm._e()])])], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?{"id":"data-v-b2998710"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/views/ViewEvent/ViewPromotion/BuyXGetYOff.vue
// module id = 1705
// module chunks = 1